/* eslint-disable */


import React from "react";

import {
  FooterContainer,
  TopSection,
  LogoAndSocials,
  Logo,
  LinkSections,
  LinkGroup,
  LinkTitle,
  FooterLink,
  BottomBar,
  SocialTextLinks
} from "./footer.styles";

import logo from "../assets/images/logo.svg";

const Footer = () => {
  return (
    <FooterContainer>
      <TopSection>
        <LogoAndSocials>
          <Logo src={logo} alt="Motivar logo" />
          <p>
            Learner Support Infrastructure for Digital Education
          </p>
        </LogoAndSocials>

        <LinkSections>
          <LinkGroup>
            <LinkTitle>Product</LinkTitle>
            <FooterLink href="/explore">Course finder</FooterLink>
            <FooterLink href="/help-learner">Sponsor a learner</FooterLink>
            <FooterLink href="/moji">Moji AI</FooterLink>
          </LinkGroup>

          <LinkGroup>
            <LinkTitle>Company</LinkTitle>
            <FooterLink href="https://medium.com/@mayorjaid/announcing-motivar-b1d13d8ef6fa" target="blank">About Us</FooterLink>
            <FooterLink href="/pricing">Pricing</FooterLink>
            <FooterLink href="mailto:contact@motivar.live">Contact</FooterLink>
          </LinkGroup>

          <LinkGroup>
            <LinkTitle>Programs</LinkTitle>
            <FooterLink href="/coming-soon">DigiAccess</FooterLink>
            <FooterLink href="/coming-soon">DAP</FooterLink>
          </LinkGroup>

          <LinkGroup>
            <LinkTitle>Resources</LinkTitle>
            <FooterLink href="/#faqs">FAQs</FooterLink>
            <FooterLink href="/coming-soon">Blog</FooterLink>
          </LinkGroup>
        </LinkSections>
      </TopSection>

      <BottomBar>
        <div>© {new Date().getFullYear()} Edu-Support Technologies. All rights reserved.</div>
        <div className="d-flex align-items-center justify-content-center" style={{ gap: '1.25rem' }}>
          <FooterLink href="/terms-of-use" style={{ margin: 0, fontSize: '13.5px' }}>Terms of Use</FooterLink>
          <FooterLink href="/privacy-policy" style={{ margin: 0, fontSize: '13.5px' }}>Privacy Policy</FooterLink>
        </div>
        <SocialTextLinks>
          <a href="https://x.com/_Motivar/" target="_blank" rel="noreferrer">Twitter</a>
          <a href="https://www.linkedin.com/company/motivar-africa" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://www.facebook.com/people/Motivar/61575912054718/" target="_blank" rel="noreferrer">Facebook</a>
        </SocialTextLinks>
      </BottomBar>
    </FooterContainer>
  );
};

export default Footer;
